module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADwSURBVHgB7ZSxEYIwFED/RwdwBEuPjg3QRbRVKycwbEAj2rKIOAIVWDICE+RLTrhLuAskhJLXQXLvXXL/ArAwAsofu/B6XCGPCWAD06g4eez7eaTdD09e9ZAzB7lg2zhixdnfAO5shgJTyXULzgECSovsGQBRNHtAyMvsdWpVNGtAlvvh5Q5IzCpAgLmrXB9AisosCYTIRa4PtPcpRHLEVq4PEDH/0AikyBS5QHkq/P1ZnQREVrwTZfxM5M3Y4vAJOqSTmMr7rEd3/CMAHMBWbhZoI+plmjPXW2QcqMGRZkoqbYAT3fobLKlJ8+gtaPkBNBeCDC9u4AUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/small-checkbox-active.png
// module id = 1066
// module chunks = 0